export default __webpack_public_path__ + "static/17-d5afcd8412e33920691904512cbde48c.jpg";